export default {
    NoReview: 1,
    AdviserReview: 2,
    AdviserCompletion: 3
  }
  